

export default {
    name: 'PageLinks',
    inject: [
        'isLogged'
    ],
    props: {
        links: Array
    }
}
